
















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
})
export default class Operation extends Vue {
  @Prop(String) name!: string;
  get buttonText (): string {
    return this.name.toLowerCase()
  }
}
